import HighchartsReact from "highcharts-react-official";
import { InfraStatsBlock } from "Backend";
import { Box } from "@mui/material";
import Highcharts from "highcharts/highstock";
import { P } from "theme/typography";

interface DataPoint {
  timestamp: number;
  value: InfraStatsBlock;
}

interface StatsData {
  title: string;
  dataPoints: DataPoint[];
}

interface StatsCardProps {
  title: string;
  subtitle: string;
  displayInflightStats: boolean;
  data: StatsData[];
}

const StatsCard = ({ title, subtitle, displayInflightStats, data }: StatsCardProps) => {
  const series: Highcharts.Options["series"] = data.map((d) => {
    return {
      name: d.title,
      type: "line",
      data: d.dataPoints.map((dataPoint) => {
        return [dataPoint.timestamp, dataPoint.value.queueSize];
      }),
    };
  });

  const options: Highcharts.Options = {
    credits: {
      enabled: false,
    },
    time: {
      useUTC: false,
    },
    title: {
      text: title,
    },
    subtitle: {
      text: subtitle,
    },
    series: series,
    tooltip: {
      xDateFormat: "%m/%d/%Y %l:%M:%S %p",
    },
    xAxis: {
      labels: {
        style: {
          fontFamily: "Inter,arial,sans-serif",
          fontSize: "10px",
        },
      },
      type: "datetime",
      dateTimeLabelFormats: {
        minute: "%l:%M %p",
        second: "%l:%M:%S %p",
        millisecond: "%H:%M:%S %p",
      },
    },
    yAxis: {
      labels: {
        style: {
          fontFamily: "Inter,arial,sans-serif",
          fontSize: "10px",
        },
      },
      title: {
        text: "Count",
      },
    },
  };

  return (
    <Box
      sx={{
        p: 1,
        backgroundColor: "white",
        borderRadius: 2,
      }}>
      <HighchartsReact highcharts={Highcharts} options={options} />
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flex: 1,
          gap: 4,
        }}>
        {displayInflightStats &&
          data.map((d) => {
            const dataPointsLength = d.dataPoints.length;
            return (
              <P variant="xlBold" key={d.title}>
                {d.title} Inflight: {dataPointsLength ? d.dataPoints[dataPointsLength - 1]?.value.inflightCount : 0}
              </P>
            );
          })}
      </Box>
    </Box>
  );
};

export default StatsCard;
